import { Button, Tooltip, useDisclosure } from '@chakra-ui/react';
import React from 'react';

import { RemoveCreditAgreementWipModal } from './RemoveCreditAgreementWipModal';
import { DeleteIconButton } from 'packages/common-frontend/components/IconButton';
import { FiTrash2 } from 'react-icons/fi';

type RemoveCreditAgreementWipButtonProps = {
  showDiscardWipButton: boolean;
  creditFacilityId: string;
  doesCreditAgreementWipExist: boolean | null;
  onSuccess?: () => void;
};
export const RemoveCreditAgreementWipButton = ({
  showDiscardWipButton,
  creditFacilityId,
  doesCreditAgreementWipExist,
  onSuccess,
}: RemoveCreditAgreementWipButtonProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      {showDiscardWipButton ? (
        <Tooltip
          label={
            !doesCreditAgreementWipExist &&
            'A WIP record does not currently exist'
          }
        >
          <Button
            onClick={onOpen}
            variant="outline"
            marginLeft={3}
            rightIcon={<FiTrash2 />}
            aria-label="discard credit agreement document wip"
            isDisabled={!doesCreditAgreementWipExist}
          >
            Discard WIP
          </Button>
        </Tooltip>
      ) : (
        <DeleteIconButton
          ariaLabel="discard"
          label="Discard"
          onClick={onOpen}
        />
      )}
      <RemoveCreditAgreementWipModal
        isOpen={isOpen}
        onClose={onClose}
        creditFacilityId={creditFacilityId}
        onSuccess={onSuccess}
      />
    </>
  );
};
